import { createApi, /* fetchBaseQuery, */ fakeBaseQuery } from '@reduxjs/toolkit/query/react'
import { getRandomIntInclusive, TRANSLATION_DETAILS } from '../../dummy-data/translationDetails';


export const api = createApi({
  reducerPath: 'api',
  baseQuery: fakeBaseQuery(), // fetchBaseQuery({ baseUrl: '/api' }),
  endpoints: (builder) => ({
    // getTranslationDetails: builder.query<TranslationRecordResponse, string>({
    //   query: (id) => `/translations/${id}`,
    // }),

    getTranslationDetails: builder.query<TranslationDetail, string>({
      queryFn: async (id) => {
        await new Promise((res) => setTimeout(res, 400));

        const item = TRANSLATION_DETAILS.find(t => t.translationRecordId === id);
        if (!item) {
          const safeIndex = getRandomIntInclusive(0, TRANSLATION_DETAILS.length - 1);
          const fallback = TRANSLATION_DETAILS[safeIndex];
          console.warn(`⚠️ ID ${id} not found. Returning fallback ${fallback.translationRecordId} instead.`);
          return { data: fallback };
        }

        return { data: item };
      },
    }),
  }),
});

export const { useGetTranslationDetailsQuery } = api;
